import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';
import BusyOverlay from './components/BusyOverlay';
import CastingView from './pages/public/CastingView';
import SelfApp from './self/SelfApp';
import NotFound from './pages/NotFound';

// Der komplette Admin-Zweig liegt hinter Zero Trust und darf NICHT im
// oeffentlichen Bundle landen: /c/:slug (Kunden-Casting) und /self/:token
// (Sprecher-Self-Service) sind ohne Login erreichbar, und ein gemeinsames
// Bundle liefert den Admin-Code an jeden dieser Besucher mit aus — im
// Inspector lesbar. Kein Datenleck (Secrets serverseitig, /api/admin/* hinter
// ZT + JWT-Gate), aber Komponenten-, Routen- und API-Pfadnamen sind
// Aufklaerungsmaterial.
// Siehe 00_TRO_DEV_DOCS/public-frontend-check.md (Check B).
const AdminRoot = lazy(() => import('./pages/admin/AdminRoot'));
const AdminLayout = lazy(() => import('./components/AdminLayout'));
const AdminHome = lazy(() => import('./pages/admin/AdminHome'));
const CastingsLayout = lazy(() => import('./pages/admin/CastingsLayout'));
const VoicesLayout = lazy(() => import('./pages/admin/VoicesLayout'));
const VoicesListPage = lazy(() => import('./pages/admin/VoicesListPage'));
const VoiceDetailPage = lazy(() => import('./pages/admin/VoiceDetailPage'));
const VoiceUploadStep = lazy(() => import('./pages/admin/VoiceUploadStep'));
const VocabularyPage = lazy(() => import('./pages/admin/VocabularyPage'));
const AgenturenListPage = lazy(() => import('./pages/admin/AgenturenListPage'));
const AgenturDetailPage = lazy(() => import('./pages/admin/AgenturDetailPage'));

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/admin" replace /> },
  // Pfadlose Eltern-Route: EINE Suspense-Grenze fuer alle Admin-Routen, damit
  // nicht jede Route ihren eigenen Wrapper braucht. Der Fallback erscheint nur
  // hier — die oeffentlichen Zweige unten sind statisch importiert.
  // AdminRoot liefert die Admin-Provider (Casting-Warenkorb, Vokabular); es ist
  // selbst lazy, damit sie nicht im oeffentlichen Bundle landen.
  {
    element: (
      <Suspense fallback={<BusyOverlay active />}>
        <AdminRoot />
      </Suspense>
    ),
    children: [
      { path: '/admin', element: <AdminHome /> },
      {
        path: '/admin/castings/*',
        element: (
          <AdminLayout title="Castings">
            <CastingsLayout />
          </AdminLayout>
        ),
      },
      { path: '/admin/voices', element: <VoicesListPage /> },
      { path: '/admin/voices/new', element: <VoiceDetailPage isNew /> },
      { path: '/admin/voices/:id/upload', element: <VoiceUploadStep /> },
      { path: '/admin/voices/:id', element: <VoiceDetailPage /> },
      { path: '/admin/vokabular', element: <VocabularyPage /> },
      { path: '/admin/tags', element: <Navigate to="/admin/vokabular?kind=tag" replace /> },
      { path: '/admin/agenturen', element: <AgenturenListPage /> },
      { path: '/admin/agenturen/new', element: <AgenturDetailPage isNew /> },
      { path: '/admin/agenturen/:id', element: <AgenturDetailPage /> },
      {
        path: '/admin/aivoices/*',
        element: (
          <AdminLayout title="AI Voices">
            <VoicesLayout />
          </AdminLayout>
        ),
      },
    ],
  },
  { path: '/c/:slug', element: <CastingView /> },
  // Öffentliche Self-Service-Fläche — eigener Zweig, KEIN AdminLayout/ZT.
  { path: '/self/:token', element: <SelfApp /> },
  { path: '*', element: <NotFound /> },
]);

export default router;
